import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import ShareWithGallery from "../component/ShareWithGallery";
import InjectScript from "../CustomScript";
import HelperScript from "../../utils/helper";
import ShareWith from "../component/ShareWith";
import Comment from "../pages/comment";
import Login from "../pages/Login";
import HomeTaboola from "./HomeTaboola";
import ReactGA from "react-ga4";
import ComscoreTracker from "../../ComscoreTracker";
import GalleryMorePage from "./GalleryMorePage";
const ScrollPage = ({ innerData, isScrollUpdate }) => {
  const sections = Array.from(
    { length: innerData?.images?.length },
    (_, i) => i + 1,
  ); // Example sections/slides
  const { 21: assetbaseUrl, 39: sharerMsg } = useSelector(
    (state) => state?.SettingReducer?.data,
  );
  const { 99: ArticleContent } = useSelector(
    (state) => state?.widgetReducer?.data,
  );

  const timeline = useSelector((state) => state?.PostReducer?.data?.timeline);
  const [postCommentModalView, setPostCommentModalView] = useState(false);
  const [showFullContent, setShowFullContent] = useState(false);

  const [comCount, setcomCount] = useState(0);

  const showPostComment = useCallback(() => {
    setPostCommentModalView((prev) => !prev);
  }, []);
  const lastViewedRef = React.useRef(null);

  useEffect(() => {
    // SCROLL TO DIV BASED ON URL PARAM
    const sectionId = window.location.search.replace("?", "");

    // Check if we need to reveal content for a deep link
    if (sectionId && innerData?.images && !showFullContent) {
      const sectionIndex = innerData.images.findIndex(
        (img) => img.image_id.toString() === sectionId
      );
      if (sectionIndex >= 4) {
        setShowFullContent(true);
        // We return here because setting state will trigger a re-run of this effect
        // with showFullContent = true, which will then handle the scroll and observer.
        return;
      }
    }

    let isInitialScroll = false;

    if (sectionId) {
      isInitialScroll = true;
      // Add a small delay to ensure DOM is ready

      setTimeout(() => {
        const element = document.getElementById(sectionId);

        if (element) {
          const elementRect = element.getBoundingClientRect();
          const absoluteElementTop = elementRect.top + window.pageYOffset;
          const middle = absoluteElementTop - window.innerHeight / 2 + 280; // Added 100px offset to move up from center

          window.scrollTo({
            top: middle,
            behavior: "smooth",
          });

          // Re-enable intersection observer after scroll completes
          setTimeout(() => {
            isInitialScroll = false;
          }, 1000); // Wait for smooth scroll to complete
        }
      }, 100);
    }

    // INTERSECTION OBSERVER FOR URL UPDATE
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !isInitialScroll) {
            const id = entry.target.getAttribute("id");
            window.history.replaceState(null, "", `?${id}`);
            // ReactGA.event({
            //   hitType: "pageview",
            //   category: "Article Page",
            //   action: "Gallery",
            //   label: id,
            // });

            // 👉 Avoid duplicate firing
            // if (lastViewedRef.current !== id) {
            //   lastViewedRef.current = id;

            //   // 👉 Correct GA4 pageview event
            //   window.gtag("event", "page_view", {
            //     page_path: `${window.location.pathname}?${id}`,
            //     page_location: `${window.location.origin}${window.location.pathname}?${id}`,
            //     page_title: `${document.title} | Slide ${id}`,
            //   });

            // }

            window._comscore = window._comscore || [];
            window._comscore.push({
              c1: "2",
              c2: "38736750",
              page: `${window.location.pathname}?${id}`,
            });

            // Force SPA beacon
            if (window.COMSCORE && window.COMSCORE.beacon) {
              window.COMSCORE.beacon({
                c1: "2",
                c2: "38736750",
                page: `${window.location.pathname}?${id}`,
              });
            }

            ReactGA.send({
              hitType: "pageview",
              page: `${window.location.pathname}?${id}`,
              title: "Gallery",
            });
            // console.log(`${window.location.pathname}?${id}`, "scrolllllllllll");
          }
        });
      },
      { threshold: 0.6 },
    );

    const targets = document.querySelectorAll("[data-section]");
    targets.forEach((section) => observer.observe(section));

    return () => {
      targets.forEach((section) => observer.unobserve(section));
    };
  }, [showFullContent, innerData]);

  const taboolacontent =
    "" +
    "" +
    '<div id="taboola-right-rail-thumbnails"></div>' +
    '<script type="text/javascript">' +
    "window._taboola = window._taboola || [];" +
    "_taboola.push({" +
    "mode: 'thumbnails-rr'," +
    "container: 'taboola-right-rail-thumbnails'," +
    "placement: 'Right Rail Thumbnails'," +
    "target_type: 'mix'" +
    "});" +
    "</script>" +
    "" +
    "";

  const taboolarelatedcontent =
    "" +
    "" +
    '<div id="taboola-related-articles-widget-thumbnails"></div>' +
    '<script type="text/javascript">' +
    "window._taboola = window._taboola || [];" +
    "_taboola.push({" +
    "mode: 'thumbnails-b'," +
    "container: 'taboola-related-articles-widget-thumbnails'," +
    "placement: 'Related Articles Widget Thumbnails'," +
    "target_type: 'mix'" +
    "});" +
    "</script>" +
    "" +
    '<script type="text/javascript">' +
    "window._taboola = window._taboola || [];" +
    " _taboola.push({flush: true});" +
    "</script>" +
    "";

  const bannerAds =
    "" +
    "<div id='div-gpt-ad-1670999306599-0' style='min-width: 728px; min-height: 90px;'>" +
    "<script>" +
    "window.googletag = window.googletag || {cmd: []};" +
    "googletag.cmd.push(function() {" +
    "googletag.defineSlot('/22678428348/SDPL_AP_BelowArticle_728x90', [728, 90], 'div-gpt-ad-1670999306599-0').addService(googletag.pubads());" +
    "googletag.pubads().enableSingleRequest();" +
    "googletag.enableServices();" +
    "});" +
    "</script>" +
    "<script>" +
    "googletag.cmd.push(function() { googletag.display('div-gpt-ad-1670999306599-0'); });" +
    "</script>" +
    "</div>" +
    "";

  const scrollUpHandler = () => {
    const currentSectionId = window.location.search.replace("?", "");
    const currentIndex = innerData?.images?.findIndex(
      (img) => img.image_id.toString() === currentSectionId,
    );
    if (currentIndex > 0) {
      const prevImage = innerData?.images[currentIndex - 1];
      const element = document.getElementById(prevImage?.image_id);
      if (element) {
        const elementRect = element.getBoundingClientRect();
        const absoluteElementTop = elementRect.top + window.pageYOffset;
        const middle = absoluteElementTop - window.innerHeight / 2 + 280;
        // console.log("Hiii");
        // ReactGA.event({
        //   hitType: "pageview",
        //   category: "Article Page",
        //   action: "Gallery",

        //   label: innerData?.url + prevImage.image_id,
        // });
        // Legacy queue (safe)
        window._comscore = window._comscore || [];
        window._comscore.push({
          c1: "2",
          c2: "38736750",
          page: `${window.location.pathname}?${prevImage.image_id}`,
        });

        // Force SPA beacon
        if (window.COMSCORE && window.COMSCORE.beacon) {
          window.COMSCORE.beacon({
            c1: "2",
            c2: "38736750",
            page: `${window.location.pathname}?${prevImage.image_id}`,
          });
        }

        ReactGA.send({
          hitType: "pageview",
          page: `${window.location.pathname}?${prevImage.image_id}`,
          title: "Gallery",
        });
        // console.log( `${window.location.pathname}?${prevImage.image_id}`, "Upppppppppppp");
        //    const currentPage =
        // location.pathname + location.search;

        // 🔐 Prevent duplicate hits for same URL
        // if (lastPageRef.current === currentPage) return;

        // lastPageRef.current = currentPage;

        // Legacy queue (safe)

        // Update URL
        window.history.replaceState(null, "", `?${prevImage.image_id}`);
      }
    }
  };

  const scrollDownHandler = () => {
    const currentSectionId = window.location.search.replace("?", "");
    const currentIndex =
      innerData?.images?.findIndex(
        (img) => img.image_id.toString() === currentSectionId,
      ) || 0;

    if (currentIndex < innerData?.images?.length - 1) {
      const nextImage = innerData?.images[currentIndex + 1];
      const element = document.getElementById(nextImage?.image_id);
      if (element) {
        const elementRect = element.getBoundingClientRect();
        const absoluteElementTop = elementRect.top + window.pageYOffset;
        const middle = absoluteElementTop - window.innerHeight / 2 + 280;

        // ReactGA.event({
        //   hitType: "pageview",
        //   category: "Article Page",
        //   action: "Gallery",

        //   label: innerData?.url + nextImage.image_id,
        // });
        // comscore Tag
        window._comscore = window._comscore || [];
        window._comscore.push({
          c1: "2",
          c2: "38736750",
          page: `${window.location.pathname}?${nextImage.image_id}`,
        });

        // Force SPA beacon
        if (window.COMSCORE && window.COMSCORE.beacon) {
          window.COMSCORE.beacon({
            c1: "2",
            c2: "38736750",
            page: `${window.location.pathname}?${nextImage.image_id}`,
          });
        }
        ReactGA.send({
          hitType: "pageview",
          page: `${window.location.pathname}?${nextImage.image_id}`,
          title: "Gallery",
        });

        // console.log(
        //   window.location.pathname + window.location.search,
        //   "downnnnnnnnnnn"
        // );

        window.scrollTo({
          top: middle,
          behavior: "smooth",
        });

        // Update URL
        window.history.replaceState(null, "", `?${nextImage.image_id}`);
      }
    }
  };

  const setCountCom = (c) => {
    setcomCount(c);
  };
  return (
    <>
      <section className="GalleryInner" id="myGalleyImg0">
        <div className="container my-4">
          <div className="row">
            <div className="col-md-1    ">
              <div className="left-icon-fixed displaynone">
                <ShareWithGallery
                  key={window.location.href}
                  url={window.location.href}
                  title={document.title}
                  dataid={innerData?.id}
                />
                <div className="left-icon-fixed-up-down mt-5">
                  <p
                    onClick={scrollUpHandler}
                    className="left-icon-border mt-4"
                  >
                    <i className="fas fa-chevron-up left-fixed-icon-border"></i>
                  </p>
                  <p className="left-icon-border" onClick={scrollDownHandler}>
                    <i className="fas fa-chevron-down left-fixed-icon-border"></i>
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="shadow p-3 mb-3 bg-white rounded">
                <h1 className="gallery-head-title">{innerData?.title}</h1>
                <div className="post-content-gallery">
                  {ArticleContent?.[0]?.script ? (
                    <InjectScript
                      script={(innerData?.short_description?.trim()
                        ? innerData.short_description
                        : innerData?.content
                      )
                        ?.replace(/<p([^>])>(.?)<\/p>/i, "<h2$1>$2</h2>")
                        ?.replace("[[$ad]]", ArticleContent?.[0]?.script)
                        ?.replace("[[$googlead]]", " ")
                        ?.replace("[[$alsoread]]", " ")}
                    />
                  ) : (
                    <InjectScript
                      script={(innerData?.short_description?.trim()
                        ? innerData.short_description
                        : innerData?.content
                      )
                        ?.replace("[[$ad]]", "")
                        ?.replace("[[$googlead]]", " ")
                        ?.replace("[[$alsoread]]", " ")}
                    />
                  )}
                </div>
              </div>
              {innerData?.images?.map((img, index) => (
                <React.Fragment key={img.image_id}>
                  {(index < 4 || showFullContent) && (
                    <div
                      id={`${img.image_id}`}
                      data-section
                      style={
                        {
                          // height: "70vh",
                        }
                      }
                    >
                      <>
                        <div
                          className="card mb-3 scrollValue"
                          id={`myGalleyImg${index + 1}`}
                          data-index={index + 1}
                        >
                          <span className="sticky-num">
                            {index + 1}
                            <em>/{innerData?.images?.length}</em>
                          </span>
                          <img
                            loading="lazy"
                            className="card-img-tops"
                            src={`${assetbaseUrl?.value}${img?.media}`}
                            alt={img?.media_title}
                          />
                        </div>
                        <p
                          className="mb-2 mt-2"
                          style={{ fontSize: "17px" }}
                          dangerouslySetInnerHTML={{
                            __html: img.content,
                          }}
                        />
                      </>
                    </div>
                  )}

                  {index === 3 &&
                    !showFullContent &&
                    innerData?.images?.length > 4 && (
                      <div className="read-more-wrapper mb-3">
                        <div style={{ position: "relative" }}>
                          {/* Blur Overlay */}
                          <div
                            style={{
                              position: "absolute",
                              bottom: "40px",
                              left: 0,
                              width: "100%",
                              height: "40px",
                              backdropFilter: "blur(1px)",
                              WebkitBackdropFilter: "blur(1px)",
                              background:
                                "linear-gradient(to bottom, rgba(255, 255, 255, 0.45), rgba(255, 255, 255, 1))",
                              pointerEvents: "none",
                              zIndex: 1,
                            }}
                          ></div>

                          {/* Read More Button */}
                          <button
                            onClick={() =>{ 
                              setShowFullContent(true);
                              ReactGA.send({
                              hitType: "pageview",
                              page: window.location.pathname + window.location.search,
                              title: "Article Page",
                            })}}
                            type="button"
                            className="py-4 font-normal text-sm relative overflow-visible w-100"
                            style={{
                              border: "none",
                              color: "#ae0a0b",
                              backgroundColor: "white",
                              position: "relative",
                              width: "100%",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              cursor: "pointer",
                              boxShadow:
                                "0 16px 15px rgba(255, 255, 255, 0.1), 0 12px 8px rgba(250, 250, 250, 0.08)",
                              padding: "8px 25px",
                              height: "50px",
                            }}
                          >
                            <span
                              style={{
                                position: "absolute",
                                left: 0,
                                top: "50%",
                                transform: "translateY(-50%)",
                                width: "100%",
                                height: "2px",
                                backgroundColor: "#ae0a0b",
                                zIndex: 2,
                              }}
                            ></span>
                            <span
                              style={{
                                position: "relative",
                                zIndex: 3,
                                backgroundColor: "#ffffff",
                                padding: "6px 30px",
                                color: "#333333",
                                fontWeight: "bold",
                                borderRadius: "50px",
                                border: "2px solid #ae0a0b",
                              }}
                            >
                              વધુ વાંચો
                            </span>
                          </button>
                        </div>
                      </div>
                    )}
                </React.Fragment>
              ))}
              <GalleryMorePage innerData={innerData} assetbaseUrl={assetbaseUrl} isScrollUpdate={isScrollUpdate} />
            </div>
            <div className="col-md-3">
              <div className="my-2">
                <div className="ad-section">
                  <HelperScript argSmall={213} argLarge={112} />
                </div>
                {/* } */}
              </div>
              <div className="my-2">
                <div className="ad-section">
                  <HelperScript argSmall={214} argLarge={113} />
                  {/* {
                                    window.innerWidth < 991 ?
                                    <InjectScript script={galleryinner214} />
                                    :
                                    <InjectScript script={galleryinner113} />
                                } */}
                </div>
              </div>
              <div className="my-2">
                <div className="ad-section">
                  <HelperScript argSmall={215} argLarge={114} />
                  {/* {
                                    window.innerWidth < 991 ?
                                    <InjectScript script={galleryinner215} />
                                    :
                                    <InjectScript script={galleryinner114} />
                                } */}
                </div>
              </div>
              <div className="my-2">
                <div className="ad-section">
                  <HelperScript argSmall={216} argLarge={115} />
                  {/* {
                                    window.innerWidth < 991 ?
                                    <InjectScript script={galleryinner216} />
                                    :
                                    <InjectScript script={galleryinner115} />
                                } */}
                </div>
              </div>
              <div className="my-2">
                <div className="ad-section">
                  <HelperScript argSmall={217} argLarge={119} />
                  {/* {
                                    window.innerWidth < 991 ?
                                    <InjectScript script={galleryinner217} />
                                    :
                                    <InjectScript script={galleryinner119} />
                                } */}
                </div>
              </div>
              <div className="my-2">
                <div className="ad-section">
                  <HelperScript argSmall={218} argLarge={120} />
                  {/* {
                                    window.innerWidth < 991 ?
                                    <InjectScript script={galleryinner218} />
                                    :
                                    <InjectScript script={galleryinner120} />
                                } */}
                </div>
              </div>
              <div className="my-2">
                <div className="ad-section">
                  <HelperScript argSmall={219} argLarge={121} />
                  {/* {
                                    window.innerWidth < 991 ?
                                    <InjectScript script={galleryinner219} />
                                    :
                                    <InjectScript script={galleryinner121} />
                                } */}
                </div>
              </div>
            </div>
            <div className="col-md-2">
              <div className="left-icon-fixed">
                <div className="row">
                  <div className="">
                    <div className="ad-section">
                      <HelperScript argSmall={220} argLarge={122} />
                      {/* {
                                    window.innerWidth < 991 ?
                                    <InjectScript script={galleryinner220} />
                                    :
                                    <InjectScript script={galleryinner122} />
                                } */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {timeline?.length > 0 &&
            timeline?.map((els, idx) => (
              <div className="live-blog">
                <div className="text-left">
                  <p className="live-blog-time">{els.date}</p>
                  {/* <div className='live-blog-title' dangerouslySetInnerHTML={{ __html: els?.message }}></div> */}
                  <div className="live-blog-title asd">
                    <InjectScript script={els?.message} />
                  </div>
                </div>
              </div>
            ))}

          {/* <div className='post-sharer' dangerouslySetInnerHTML={{ __html: sharerMsg?.value }} /> */}
          <div className={`post-sharer article-${innerData?.id}`}>
            <InjectScript script={window.innerWidth > 991 ? bannerAds : ""} />
          </div>
          <div className="d-flex justify-content-end social-post">
            <p className="social-share-text">Share With:</p>
            <ShareWith
              key={innerData?.id}
              url={innerData?.url}
              title={innerData?.title}
              dataid={innerData?.id}
              media={innerData?.media}
            />
          </div>
          <hr className="m-0" />
          <div className="mb-3 mt-3 text-center">
            {innerData?.comment_status === 1 && (
              <button
                onClick={() => {
                  showPostComment();
                }}
                type="button"
                className="btn btn-color mt-3"
              >
                Post a comment {comCount > 0 ? `(${comCount})` : null}
              </button>
            )}
          </div>
          <div className="row">
            {/* <div className="col-md-1"></div> */}
            <div className="col-md-9">
              <div className="single-blog mt-3">
                {/* <span className="badge badge-warning">Related Gallery</span> */}
                <div className="bottom-taboola" key={window.location.href}>
                  <InjectScript
                    type="taboola"
                    script={taboolarelatedcontent}
                    key={window.location.href}
                  />
                </div>
              </div>
              <HomeTaboola key={Math.random()} />
            </div>
            <div className="col-md-3">
              <div className="my-4 sidebar-taboola" key={window.location.href}>
                <InjectScript
                  type="taboola"
                  script={taboolacontent}
                  key={window.location.href}
                />
                <HelperScript argLarge={261} />
                {/* {
                                    window.innerWidth < 991 ?
                                    <InjectScript script={galleryinner261} />
                                    :
                                    ''
                                } */}
              </div>
            </div>
          </div>
        </div>
      </section>

      {localStorage.getItem("access_token") ? (
        <>
          {postCommentModalView && (
            <Comment
              postCommentModalchk={showPostComment}
              postCommentcount={setCountCom}
              postId={innerData?.id}
              innerDataProps={innerData && innerData}
            />
          )}
        </>
      ) : (
        <>{postCommentModalView && <Login />}</>
      )}
    </>
  );
};

export default ScrollPage;
